const initialState = {
  selectedFinancialYears: "",
  SelectedDate: {},
  DateForAccountVoucher: { FromDate: "", ToDate: "" },
};

export function financialYearReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_FINANCIAL_YEAR": {
      return {
        ...state,
        selectedFinancialYears: action.payload,
      };
    }
    case "SET_SELECTED_DATE": {
      return {
        ...state,
        SelectedDate: { ...state.SelectedDate, ...action.payload },
      };
    }
    case "SET_SELECTED_DATE_FOR_VOUCHER": {
      return {
        ...state,
        DateForAccountVoucher: { ...state.DateForAccountVoucher, ...action.payload },
      };
    }
    case "CLEAR_SET_SELECTED_DATE": {
      return {
        ...state,
        SelectedDate: { ...action.payload },
      };
    }
    default:
      return state;
  }
}

// Action creators
export const setFinancialYear = (financialYear) => ({
  type: "SET_FINANCIAL_YEAR",
  payload: financialYear,
});
